<template>
	<v-dialog v-model="open" max-width="440" persistent>
		<v-card rounded="lg" elevation="1">
			<v-card-title class="bg-primary d-flex align-center pa-4">
				<v-icon start icon="mdi-rocket-launch-outline" />
				<span class="text-h6">{{ $t("billing.upgrade.title") }}</span>
			</v-card-title>
			<v-card-text class="pa-4">
				<p class="text-body-1">
					{{ message || $t("billing.upgrade.defaultMessage") }}
				</p>
			</v-card-text>
			<v-card-actions class="pa-4 pt-0">
				<v-spacer />
				<v-btn variant="text" @click="close">
					{{ $t("common.close") }}
				</v-btn>
				<v-btn color="primary" variant="flat" @click="goToPlan">
					{{ $t("billing.upgrade.cta") }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { useUpgradePrompt } from "@/composables/useUpgradePrompt";

const router = useRouter();
const { open, message, close } = useUpgradePrompt();

function goToPlan() {
	close();
	router.push("/temple/plan");
}
</script>
